import { Canvas } from "../types/canvasTypes";
import { ExtendedObject, ViewportShape } from "../types/objectTypes";

export function findViewportShape(canvas: Canvas): ViewportShape | undefined {
  return canvas.getObjects().find((obj) => (obj as ExtendedObject).meaning === "viewport") as ViewportShape;
}

export const parseViewportSize = (viewport: string) => {
  const [width, height] = viewport.trim().split("x").map(Number);
  return { width, height };
};
